import script from "./donateWaqf.vue?vue&type=script&setup=true&lang=js"
export * from "./donateWaqf.vue?vue&type=script&setup=true&lang=js"

import "./donateWaqf.vue?vue&type=style&index=0&id=49c48f54&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49c48f54"]])

export default __exports__